<template>
  <div v-if="insights.length" class="md-insights">
    <div v-for="(insight, i) in insights" :key="i" class="md-insights__row" :class="`md-insights__row--${insight.tone}`">
      <span class="md-insights__icon"><i :class="insight.icon"></i></span>
      <span class="md-insights__body">
        <span class="md-insights__title">{{ insight.title }}</span>
        <span class="md-insights__text">{{ insight.text }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MdInsights',
  props: {
    // [{ tone: 'up'|'down'|'star'|'info', icon, title, text }]
    insights: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.md-insights {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.md-insights__row {
  display: flex;
  gap: 0.7rem;
  padding: 0.7rem 0.8rem;
  border-radius: 10px;
  background: var(--md-card-bg, #fff);
  border: 1px solid var(--md-card-border, rgba(34, 41, 47, 0.08));
  border-left-width: 3px;
}
.md-insights__row--up { border-left-color: #1f9d61; }
.md-insights__row--down { border-left-color: #d64545; }
.md-insights__row--star { border-left-color: #e2a93b; }
.md-insights__row--info { border-left-color: #7367f0; }
.md-insights__icon {
  flex: 0 0 auto;
  font-size: 14px;
  padding-top: 1px;
}
.md-insights__row--up .md-insights__icon { color: #1f9d61; }
.md-insights__row--down .md-insights__icon { color: #d64545; }
.md-insights__row--star .md-insights__icon { color: #e2a93b; }
.md-insights__row--info .md-insights__icon { color: #7367f0; }
.md-insights__body {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.md-insights__title {
  font-size: 12.5px;
  font-weight: 700;
  color: var(--md-strong, #24292f);
}
.md-insights__text {
  font-size: 12px;
  line-height: 1.45;
  color: var(--md-muted, #8a919c);
}

.dark-layout .md-insights__row {
  --md-card-bg: #283046;
  --md-card-border: #3b4253;
  --md-strong: #d0d2d6;
}
</style>
